<template>
  <div class="col">
    <div class="card-container">
      <div class="card">
        <img
          class="card-img-top w-100 d-block fit-cover"
          :src="obj.image"
          :alt="obj.name"
        />
        <div class="card-body p-4">
          <p
            v-if="obj.language"
            class="text-primary card-text mb-0 categoryName"
          >
            {{ obj.language.name }}
          </p>
          <p v-else class="text-primary card-text mb-0">Public</p>
          <span class="course_tag" v-if="obj.language">
            {{ obj.language.name }}</span
          >
          <h4 class="card-title">{{ obj.name }}</h4>
          <div class="d-flex">
            <button
              class="btn btn-primary float-end"
              type="button"
              @click="openGuide"
            >
              <strong>{{ buttonLabel }}</strong>
            </button>
          </div>
        </div>
      </div>
      <div class="overlay">
        <p>{{ obj.name }}</p>

        <div class="inline_summary" v-html="obj.desc"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "GuideCell",
  props: {
    obj: {},
  },
  components: {},
  mounted() {},
  computed: {
    pdfDownloadLink() {
      if (this.obj.type !== "pdf" || !this.obj.file) return null;

      try {
        const files = JSON.parse(this.obj.file);
        return files?.[0]?.download_link || null;
      } catch (e) {
        return null;
      }
    },
    buttonLabel() {
      return this.obj.type === "pdf" ? "Open Guide" : "Open Guide";
    },
  },
  methods: {
    openGuide() {
      let link = null;

      if (this.obj.type === "pdf") {
        link = this.pdfDownloadLink;
      } else {
        link = this.obj.url;
      }

      if (link) {
        window.open(link, "_blank");
      }
    },
  },
};
</script>

<style  scoped>
.inline_duration {
  background: #fca311;
  padding: 5px;
  font-size: 1rem;
  border-radius: 5px;
}
.inline_summary {
  width: 100%;
}
#courses .card-container:hover .overlay {
  align-content: flex-start;
  flex-wrap: wrap;
  padding-top: 20px;
}
#courses .card-body .categoryName {
  width: 100%;
}
.course_tag {
  background-color: #78290f;
  color: #fff;
  position: absolute;
  top: 14px;
  right: 0px;
  padding: 3px 10px;
  font-size: 0.8rem;
}
</style>